import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('AiFirstCodingExercise', LATEST_SCHEMA_VERSION.AiFirstCodingExercise);
export default exerciseTypeVersionAdapter;